/**
 * Configuração da camada de assinatura por request.
 * Ver scripts/security/08-frontend-angular-integracao.md.
 */
export const SecurityConfig = {
  headers: {
    session: 'X-Session-Id',
    nonce: 'X-Nonce',
    signature: 'X-Signature',
  },
  // Caminhos de bootstrap/camada 1 que NÃO são assinados.
  skip: [
    '/security/session',
    '/encrypt-param',
    '/decrypt-param',
    '/decrypt-params',
  ],
} as const;
